import { createContext, useContext } from 'react';

const SitckyContext = createContext();

export const { Provider, Consumer } = SitckyContext;

export const useStickyContext = () => useContext(SitckyContext);

export default SitckyContext;
